//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Error',
  props: {
    error: {
      type: Error,
      required: true,
    },
  },
  data: () => ({
    headerImg: require('~/assets/img/lid-worden.jpg'),
  }),
};
